module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/pierata.ded225a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/pierata.jpg
// module id = XzWi
// module chunks = 0